const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

export const getMonthName = (month: number) => {
    return months[month - 1];
};

export const getQuarterName = (month: number) => {
    switch (month) {
        case 3:
            return 'Q1';
        case 6:
            return 'Q2';
        case 9:
            return 'Q3';
        case 12:
            return 'Q4';
        default:
            return getMonthName(month);
    }
};

export const distributionType = (type: string | undefined, month: number) => {
    switch (type) {
        case 'Monthly':
            return getMonthName(month);
        case 'Quarterly':
            return getQuarterName(month);
        default:
            return getMonthName(month);
    }
};

export const getDistributeXAxisName = (type: string | undefined) => {
    switch (type) {
        case 'Monthly':
            return 'Month';
        case 'Quarterly':
            return 'Quarter';
        default:
            return 'Month';
    }
};

export const getRandomColor = (year: number | undefined) => {
    var letters = 'ABCDEF0123456789';
    var color = '#';
    let yearArry = (year && `${year}`.split('')) || [];
    for (var i = yearArry.length - 1; i >= 0; i--) {
        color += letters[parseInt(yearArry[i])];
    }
    return color + 'FE';
};
